import React from "react";
import Avatar from "../../../../components/avatar/avatar";

export default function ChatAvatar({
  chat,
  currentUser,
  contacts,
  active_user,
  isGroup = false,
  getUserofGroupChat = null,
}) {
  const isCurrentUser = chat.sender === currentUser?._id;

  const avatarProps = {
    fontSize: "14px",
    height: 40,
    width: 40,
  };

  if (isCurrentUser) {
    return null;
  }

  // PRIVATE CHAT
  if (!isGroup) {
    const activeContact = contacts[active_user];
    return (
      <div className="chat-avatar">
        <Avatar
          roundedFull={true}
          user={activeContact?.user}
          {...avatarProps}
        />
      </div>
    );
  }

  // GROUP CHAT
  const senderInfo = getUserofGroupChat?.(
    contacts[active_user]?.members,
    chat?.sender
  );

  return (
    <div className="chat-avatar">
      <Avatar
        roundedFull={true}
        user={senderInfo}
        {...avatarProps}
      />
    </div>
  );
}
